export default __webpack_public_path__ + "static/media/paddlepaddleQr.69ed80cb.jpg";